import styles from './DashSpinner.module.css';

interface DashSpinnerProps {
  size?: number;
  color?: string;
  hasWrapper?: boolean;
}

const DEFAULT_SIZE = 20;
const DEFAULT_COLOR = 'var(--color-gray)';

export function DashSpinner({
  size = DEFAULT_SIZE,
  color = DEFAULT_COLOR,
  hasWrapper = false
}: DashSpinnerProps) {
  const dashCount = 3; // Three dots for a clean, professional look

  const DashSpinnerComponent = (
    <div
      className={styles.dashSpinner}
      style={
        {
          '--spinner-size': `${size}px`,
          '--spinner-color': color
        } as React.CSSProperties
      }
    >
      {Array.from({ length: dashCount }, (_, index) => (
        <div key={index} className={styles.dash} />
      ))}
    </div>
  );

  if (hasWrapper) {
    return <div className={styles.spinnerWrapper}>{DashSpinnerComponent}</div>;
  }

  return DashSpinnerComponent;
}
